var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{staticClass:"animate__animated animate__fadeIn",attrs:{"src":"static/img/GM/1.jpg"}})])}]

export { render, staticRenderFns }